import React, { useEffect } from 'react';
import {
  Dialog as MaterialDialog,
  DialogContent,
  DialogTitle,
  Grid,
  DialogActions,
  Button,
} from '@material-ui/core';
import { HighlightOff } from '@material-ui/icons';
import { SimulationDetailPopUpProps } from './interfaces';
import { useStyles } from './styles';

import DetailTable from './DetailTable';
import Summary from './Summary';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import {
  activeStrategyAction,
  loadStrategyAction,
  resetStrategyRegisterAction,
} from 'modules/strategy';
import { isLoading } from 'utils/loading';
import Loading from 'components/Loading';
import { listStrategyAction } from 'modules/strategyList';
import { FORM_MODE } from 'shared/enums';

const SimulationDetailPopUp: React.FC<SimulationDetailPopUpProps> = ({
  show,
  strategy,
  handleClose,
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      loadStrategyAction({ id: strategy.id, mode: FORM_MODE.listDetail }),
    );
  }, []);

  const { loading: loadingStrategy, current: loadedStrategy } = useSelector(
    (state: RootState) => state.strategy,
  );

  const { list: simulationList } = useSelector(
    (state: RootState) => state.simulationList,
  );

  const loadedSimulation = simulationList[strategy?.id];

  const loading = isLoading([loadingStrategy]);

  const handleActiveStrategy = () => {
    dispatch(
      activeStrategyAction({ strategy, onSuccess: onSuccessAtActivate }),
    );
  };

  const onCloseDialog = () => {
    dispatch(resetStrategyRegisterAction());
    dispatch(listStrategyAction({}));
    handleClose();
  };

  const onSuccessAtActivate = () => {
    onCloseDialog();
  };

  const simulationIsReady = loadedStrategy
    ? ['SIMULATION_READY'].some((status) => loadedStrategy.status === status)
    : false;

  const isSimulationReadyAtLeast =
    loadedStrategy &&
    loadedSimulation.total &&
    loadedSimulation.serviceCategories
      ? simulationIsReady ||
        ['ACTIVE', 'ENDING'].some((status) => loadedStrategy.status === status)
      : false;

  const classes = useStyles({ smallDialog: !isSimulationReadyAtLeast });

  const isOnLoading = loading || !loadedSimulation || !loadedStrategy;

  const isOnRunSimulation = isOnLoading
    ? false
    : loadedStrategy.status === 'SIMULATING' ||
      (loadedStrategy.status === 'ACTIVE' && !loadedSimulation.activated);

  return isOnLoading ? (
    <Loading />
  ) : (
    <MaterialDialog
      open={show}
      onClose={onCloseDialog}
      maxWidth={false}
      fullWidth={isSimulationReadyAtLeast}
      PaperProps={{ className: classes.dialogPaper }}
      className={classes.dialogContainer}
    >
      <Grid
        container
        justifyContent="flex-end"
        className={classes.closeContainer}
      >
        <HighlightOff
          className={classes.closeIcon}
          color="action"
          fontSize="medium"
          onClick={onCloseDialog}
        />
      </Grid>
      {loadedSimulation && (
        <Grid
          container
          direction="column"
          justifyContent="center"
          alignItems="stretch"
          className={classes.container}
        >
          <Grid container direction="column" alignItems="center">
            <DialogTitle>Detalhes da Estratégia</DialogTitle>
            <DialogTitle>{loadedStrategy?.name || ''}</DialogTitle>
          </Grid>
          <Grid container direction="column">
            <DialogContent>
              <Summary
                percent={loadedSimulation.executedPercent}
                messageTimeRemain={loadedSimulation.messageTimeRemain || ''}
                isActivated={loadedSimulation.activated}
                status={loadedStrategy.status}
                isOnRunSimulation={isOnRunSimulation}
              />

              {isSimulationReadyAtLeast && !isOnRunSimulation && (
                <Grid container item direction="column" alignItems="center">
                  <DetailTable
                    serviceCategories={loadedSimulation.serviceCategories}
                    serviceCategoriesTotal={loadedSimulation.total}
                    isSimulation={loadedSimulation.type === 'SIMULATION'}
                  />
                </Grid>
              )}
            </DialogContent>
          </Grid>
          {simulationIsReady && (
            <Grid container direction="column" alignItems="center">
              <DialogActions>
                <Button variant="contained" onClick={handleActiveStrategy}>
                  Ativar
                </Button>
              </DialogActions>
            </Grid>
          )}
        </Grid>
      )}
    </MaterialDialog>
  );
};
export default SimulationDetailPopUp;
